import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';

import { BetriebskontakteNeuerKontaktDialogComponent } from './betriebskontakte-neuer-kontakt-dialog.component';
import { BetriebskontaktCardModule } from './betriebskontakt-card.module';

@NgModule({
    declarations: [BetriebskontakteNeuerKontaktDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatCheckboxModule,
        MatCardModule,
        BetriebskontaktCardModule,
    ],
    exports: [BetriebskontakteNeuerKontaktDialogComponent],
})
export class BetriebskontakteDialogsModule {}
